import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productsApi = createApi({

  reducerPath: 'productsApi',

  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Products'],
  keepUnusedDataFor: 86400000,
  refetchOnMountOrArgChange: 1,

  endpoints: (builder) => ({
    fetch: builder.query({
      query: (data) => ({
        url: `products?page=${data.page}&size=${data.size}&in_search=${data.inSearch}&popular=${data.popular}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Products'],
    }),

    show: builder.query({
      query: (data) => ({
        url: `products/${data.id}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      // keepUnusedDataFor: 1,
      providesTags: ['Products'],
    }),

    storeProducts: builder.query({
      query: (data) => ({
        url: `products/store/${data.id}?page=${data.page}&size=${data.size}&searchid=${data.searchquery && data.searchquery}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Products'],
    }),


    delete: builder.mutation({
      query: (data) => {
        return {
          url: `products/${data.id}`,
          method: 'DELETE',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),

    create: builder.mutation({
      query: (data) => ({
        url: `products`,
        method: 'POST',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),

    update: builder.mutation({
      query: (data) => ({
        url: `products/${data.id}`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),


    fetchPrice: builder.mutation({
      query: (data) => ({
        url: `products/${data.id}/${data.pcountry}/${data.tcountry}`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),



    deleteMedia: builder.mutation({
      query: (data) => ({
        url: `products/${data.id}`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),



    updateMedia: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        Object.values(data.image_file).forEach(file => {
          formData.append("myFile", file);
        });
        return {
          url: `products/${data.id}`,
          method: 'PUT',
          body: formData,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            // 'Content-Type': 'multipart/form-data',
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),



    updateFile: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.image_file);
        return {
          url: `products`,
          method: 'POST',
          body: formData,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            // 'Content-Type': 'multipart/form-data',
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'X-Store-Id': data.store_id
          }
        }
      },
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Products'],
    }),


    importFile: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.image_file);
        return {
          url: `store/products`,
          method: 'POST',
          body: formData,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            // 'Content-Type': 'multipart/form-data',
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'X-Store-Id': data.store_id
          }
        }
      },
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Products'],
    }),


    fetchStoreProductsCashed: builder.query({
      query: (data) => ({
        url: `store/products/${data.id}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Products'],
    }),



    createProduct: builder.mutation({
      query: (data) => {
        return {
          url: `create_products`,
          method: 'POST',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),

    refetchProducts: builder.mutation({
      query: (data) => {
        return {
          url: `refetch/products/${data.store_id}`,
          method: 'POST',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),
    refetchIndex: builder.query({
      query: (data) => ({
        url: `refetch/products/${data.store_id}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Products'],
    }),
    refetchUpdate: builder.mutation({
      query: (data) => ({
        url: `refetch/products/${data.store_id}`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),


    createProductsIndex: builder.query({
      query: (data) => ({
        url: `create_products`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Products'],
    }),
    createProductsUpdate: builder.mutation({
      query: (data) => ({
        url: `create_products`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),


    splitProducts: builder.mutation({
      query: (data) => ({
        url: `store/split`,
        method: 'POST',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Products'],
    }),





  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useFetchQuery, useFetchStoreProductsCashedQuery, useShowQuery, useStoreProductsQuery, useDeleteMutation, useCreateMutation, useUpdateMutation, useUpdateMediaMutation, useDeleteMediaMutation, useUpdateFileMutation, useImportFileMutation, useFetchPriceMutation, useCreateProductMutation, useRefetchProductsMutation, useRefetchIndexQuery, useRefetchUpdateMutation, useCreateProductsIndexQuery, useCreateProductsUpdateMutation, useSplitProductsMutation } = productsApi